module.exports = "/_next/static/images/photoSergiuTasmali-abd66fc79468d52bf7b5b3f412dd43cc.webp";